export default __webpack_public_path__ + "static/media/RhymesCountAlong_04.121a5807.png";